import { ReactElement, useMemo, useCallback, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareFromSquare as ShareIcon } from '@fortawesome/free-solid-svg-icons';

import { getUrlTrackingOrder, openUrlInNewTab } from '~utils/commons';
import { TRACKING_PAGE_URL } from '~constants/commons';

import { TrackingOrderPageInfoProps } from './types';
import {
  TrackingOrderPageInfoContainer,
  TrackingOrderPageInfoChip,
  TrackingOrderPageInfoCopyButton,
} from './styles';

const TrackingOrderPageInfo = ({
  trackingCode,
}: TrackingOrderPageInfoProps): ReactElement => {
  const urlTrackingOrderPage = useMemo(
    () => getUrlTrackingOrder(trackingCode),
    [trackingCode],
  );

  const labelChip = useMemo(
    () => (
      <>
        {TRACKING_PAGE_URL}/<b>{trackingCode}</b>
      </>
    ),
    [trackingCode],
  );

  const handleRedirectToTrackinOrderPage = useCallback(() => {
    openUrlInNewTab(urlTrackingOrderPage);
  }, [urlTrackingOrderPage]);

  return (
    <TrackingOrderPageInfoContainer>
      <TrackingOrderPageInfoChip
        variant="outlined"
        icon={<FontAwesomeIcon icon={ShareIcon} />}
        label={labelChip}
        onClick={handleRedirectToTrackinOrderPage}
      />

      <TrackingOrderPageInfoCopyButton
        color="primary"
        text={urlTrackingOrderPage}
      />
    </TrackingOrderPageInfoContainer>
  );
};

export default memo(TrackingOrderPageInfo);
